var moduleMap = {
	"./ideAITutorRemoteEntry": function() {
		return Promise.all([__webpack_require__.e(5218), __webpack_require__.e(66983), __webpack_require__.e(98998), __webpack_require__.e(69141), __webpack_require__.e(73219), __webpack_require__.e(91237), __webpack_require__.e(12078), __webpack_require__.e(9272), __webpack_require__.e(25137), __webpack_require__.e(54584), __webpack_require__.e(72608), __webpack_require__.e(29202)]).then(function() { return function() { return (__webpack_require__(884012)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});